// extracted by mini-css-extract-plugin
export default {"tooltip":"mp-z","sharingV2":"np-z","sharingIconsV2":"op-z","links":"pp-z","link":"qp-z","facebookV2":"rp-z","twitterV2":"sp-z","pinterestV2":"tp-z"};